export default __webpack_public_path__ + "static/media/sanford bishop.3b45e2a6.jpg";